import { render, staticRenderFns } from "./AspectosLegales.vue?vue&type=template&id=b8fbfaf0&scoped=true&"
var script = {}
import style0 from "./AspectosLegales.vue?vue&type=style&index=0&id=b8fbfaf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fbfaf0",
  null
  
)

export default component.exports